import { render, staticRenderFns } from "./veJkyMeetShow.vue?vue&type=template&id=2b39027c&scoped=true"
import script from "./veJkyMeetShow.vue?vue&type=script&lang=js"
export * from "./veJkyMeetShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39027c",
  null
  
)

export default component.exports